// extracted by mini-css-extract-plugin
export default {"underlay":"Underlay_underlay__fChIt","blackBackground":"Underlay_blackBackground__mUdVo"};